<script lang="ts">
  import { afterUpdate } from "svelte";
  import { BackgroundDimensions } from "../store/AppState";
  import { assetsProgress, backgroundLoaded } from "../store/AppState";

  let imageElement: HTMLImageElement;
  export let onLoad: () => void;

  const setDimensions = (dimensions: { width: number; height: number }) => {
    BackgroundDimensions.set(dimensions);
  };

  const handleLoad = () => {
    window.dispatchEvent(new Event("resize"));
    onLoad();
    $assetsProgress += 1;
    $backgroundLoaded = true;
  };

  const calculateHeight = () => {
    if (imageElement) {
      setDimensions({
        width: imageElement.clientWidth,
        height: imageElement.clientHeight,
      });
    }
  };

  window.addEventListener("resize", () => {
    calculateHeight();
  });
  window.addEventListener("orientationchange", () => {
    window.dispatchEvent(new Event("resize"));
  });

  afterUpdate(() => {
    calculateHeight();
  });
</script>

<div class="background-container">
  <img
    bind:this={imageElement}
    on:load={() => handleLoad()}
    class="background"
    src={`${__PUBLIC_PATH__}images/pozadi.png`}
    alt="background"
    style={`--height: ${
      __MODE__ === "production" ? "calc(100dvh - 6.4rem)" : "100dvh"
    }`}
  />
</div>

<style>
  .background-container {
    z-index: 1;
    display: inline-block;
  }

  .background {
    height: var(--height);
  }
</style>
